import { KarateIcon } from './KarateIcon';

/**
 * author: Google
 * id 85144563-B019-4B8A-AB76-3DE0797D517E
 * name karate
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/karate.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const HumanKarateIcon = KarateIcon;
export default HumanKarateIcon